/**
 * @generated SignedSource<<f0fdeccc28ae3e2d67e22c2f0a07dae1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Questions_Query$variables = {
  hasCategory: boolean;
  slug: string;
  title?: string | null | undefined;
};
export type Questions_Query$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"AuthGate_User" | "Question_User" | "Questions_isAllowed" | "auth_checkAuthForPage" | "user_isClient" | "user_isGuest">;
  } | null | undefined;
  readonly questionCategory?: {
    readonly __typename: "Industry";
    readonly featuredQuestions: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Question_Question">;
    }> | null | undefined;
    readonly name: string;
  } | {
    readonly __typename: "Skill";
    readonly featuredQuestions: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Question_Question">;
    }> | null | undefined;
    readonly name: string;
  } | {
    readonly __typename: "Specialization";
    readonly featuredQuestions: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Question_Question">;
    }> | null | undefined;
    readonly name: string;
  } | {
    readonly __typename: "Tag";
    readonly featuredQuestions: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Question_Question">;
    }> | null | undefined;
    readonly name: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly questions?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Question_Question">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type Questions_Query = {
  response: Questions_Query$data;
  variables: Questions_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasCategory"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guest",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isGuest",
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isClient",
  "storageKey": null
},
v7 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isClient",
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confirmedEmail",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passwordSetupRequired",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unconfirmedEmail",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationName",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "statuses": [
        "active",
        "paused"
      ]
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enableTimesheets",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowExpensesAccess",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentsEnabled",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v17 = {
  "kind": "Literal",
  "name": "first",
  "value": 0
},
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v19 = {
  "alias": "offers",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "statuses": [
          "offer_made"
        ]
      }
    },
    (v17/*: any*/)
  ],
  "concreteType": "ContractConnection",
  "kind": "LinkedField",
  "name": "freelancerContracts",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": "freelancerContracts(filters:{\"statuses\":[\"offer_made\"]},first:0)"
},
v20 = {
  "alias": "interviews",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "stage": "interview"
      }
    },
    (v17/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"stage\":\"interview\"},first:0)"
},
v21 = {
  "alias": "screening",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "withJobScreening": true
      }
    },
    (v17/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"withJobScreening\":true},first:0)"
},
v22 = {
  "alias": "applications",
  "args": [
    {
      "kind": "Literal",
      "name": "filters",
      "value": {
        "statuses": [
          "job_application_sent",
          "job_application_draft"
        ]
      }
    },
    (v17/*: any*/)
  ],
  "concreteType": "JobApplicationConnection",
  "kind": "LinkedField",
  "name": "freelancerJobApplications",
  "plural": false,
  "selections": (v18/*: any*/),
  "storageKey": "freelancerJobApplications(filters:{\"statuses\":[\"job_application_sent\",\"job_application_draft\"]},first:0)"
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v24 = {
  "kind": "InlineDataFragmentSpread",
  "name": "user_isMember",
  "selections": [
    (v4/*: any*/),
    (v23/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v25 = [
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "featured",
        "value": true
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v27 = [
  (v26/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "Question_Question"
  }
],
v28 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v31 = [
  (v30/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Question",
    "kind": "LinkedField",
    "name": "featuredQuestions",
    "plural": true,
    "selections": (v27/*: any*/),
    "storageKey": null
  }
],
v32 = [
  (v26/*: any*/),
  (v30/*: any*/)
],
v33 = [
  (v26/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Industry",
    "kind": "LinkedField",
    "name": "industries",
    "plural": true,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Specialization",
    "kind": "LinkedField",
    "name": "specializations",
    "plural": true,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Skill",
    "kind": "LinkedField",
    "name": "skills",
    "plural": true,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Tag",
    "kind": "LinkedField",
    "name": "tags",
    "plural": true,
    "selections": (v32/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rawId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Answer",
    "kind": "LinkedField",
    "name": "videoAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Video",
        "kind": "LinkedField",
        "name": "video",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      (v26/*: any*/)
    ],
    "storageKey": null
  }
],
v34 = [
  (v30/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Question",
    "kind": "LinkedField",
    "name": "featuredQuestions",
    "plural": true,
    "selections": (v33/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Questions_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineDataFragmentSpread",
            "name": "Questions_isAllowed",
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "auth_needsAccountSetup",
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "auth_checkAuthForPage",
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "auth_getRedirectPath",
                "selections": [
                  (v4/*: any*/),
                  (v10/*: any*/),
                  (v8/*: any*/),
                  (v11/*: any*/),
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "auth_getDefaultPath",
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": "activeContracts",
                        "args": (v12/*: any*/),
                        "concreteType": "ContractConnection",
                        "kind": "LinkedField",
                        "name": "freelancerContracts",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Contract",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Firm",
                                "kind": "LinkedField",
                                "name": "firm",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
                      },
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v24/*: any*/),
                      (v7/*: any*/),
                      (v5/*: any*/)
                    ],
                    "args": null,
                    "argumentDefinitions": []
                  },
                  (v5/*: any*/),
                  (v24/*: any*/),
                  (v7/*: any*/)
                ],
                "args": null,
                "argumentDefinitions": []
              }
            ],
            "args": null,
            "argumentDefinitions": []
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Question_User"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AuthGate_User"
          }
        ],
        "storageKey": null
      },
      {
        "condition": "hasCategory",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v25/*: any*/),
            "concreteType": "QuestionConnection",
            "kind": "LinkedField",
            "name": "questions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v27/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasCategory",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v28/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "questionCategory",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v31/*: any*/),
                "type": "Industry",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v31/*: any*/),
                "type": "Specialization",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v31/*: any*/),
                "type": "Skill",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v31/*: any*/),
                "type": "Tag",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "Questions_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": "activeContracts",
            "args": (v12/*: any*/),
            "concreteType": "ContractConnection",
            "kind": "LinkedField",
            "name": "freelancerContracts",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Contract",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Firm",
                    "kind": "LinkedField",
                    "name": "firm",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v26/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "freelancerContracts(filters:{\"statuses\":[\"active\",\"paused\"]},first:1)"
          },
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v26/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "hasCategory",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v25/*: any*/),
            "concreteType": "QuestionConnection",
            "kind": "LinkedField",
            "name": "questions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Question",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v33/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasCategory",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v28/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "questionCategory",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v34/*: any*/),
                "type": "Industry",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v34/*: any*/),
                "type": "Specialization",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v34/*: any*/),
                "type": "Skill",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v34/*: any*/),
                "type": "Tag",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v26/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "38d472e4edaa3fa565b16514dd318a37",
    "id": null,
    "metadata": {},
    "name": "Questions_Query",
    "operationKind": "query",
    "text": "query Questions_Query(\n  $title: String\n  $hasCategory: Boolean!\n  $slug: String!\n) {\n  currentUser {\n    ...user_isGuest\n    ...user_isClient\n    ...Questions_isAllowed\n    ...auth_checkAuthForPage\n    ...Question_User\n    ...AuthGate_User\n    id\n  }\n  questions(first: 40, filters: {featured: true, title: $title}) @skip(if: $hasCategory) {\n    nodes {\n      id\n      ...Question_Question\n    }\n  }\n  questionCategory(slug: $slug) @include(if: $hasCategory) {\n    __typename\n    ... on Industry {\n      name\n      featuredQuestions {\n        id\n        ...Question_Question\n      }\n    }\n    ... on Specialization {\n      name\n      featuredQuestions {\n        id\n        ...Question_Question\n      }\n    }\n    ... on Skill {\n      name\n      featuredQuestions {\n        id\n        ...Question_Question\n      }\n    }\n    ... on Tag {\n      name\n      featuredQuestions {\n        id\n        ...Question_Question\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment AuthGate_User on User {\n  ...auth_useAuthGate\n}\n\nfragment QuestionActions_Question on Question {\n  id\n  rawId\n  title\n  ...RecordVideoButton_Question\n}\n\nfragment QuestionActions_User on User {\n  ...user_useIsGuest\n  ...user_useIsClient\n  ...user_useIsMember\n}\n\nfragment QuestionSubheader_Question on Question {\n  industries {\n    id\n    name\n  }\n  specializations {\n    id\n    name\n  }\n  skills {\n    id\n    name\n  }\n  tags {\n    id\n    name\n  }\n}\n\nfragment Question_Question on Question {\n  title\n  description\n  ...QuestionSubheader_Question\n  ...QuestionActions_Question\n}\n\nfragment Question_User on User {\n  id\n  ...QuestionActions_User\n}\n\nfragment Questions_isAllowed on User {\n  ...auth_needsAccountSetup\n}\n\nfragment RecordVideoButton_Question on Question {\n  id\n  rawId\n  title\n  videoAnswer {\n    video {\n      ...RecordVideoButton_Video\n      id\n    }\n    id\n  }\n}\n\nfragment RecordVideoButton_Video on Video {\n  url\n}\n\nfragment auth_checkAuthForPage on User {\n  ...auth_getRedirectPath\n}\n\nfragment auth_getDefaultPath on User {\n  confirmedEmail\n  passwordSetupRequired\n  status\n  activeContracts: freelancerContracts(first: 1, filters: {statuses: [active, paused]}) {\n    nodes {\n      enableTimesheets\n      allowExpensesAccess\n      paymentsEnabled\n      firm {\n        slug\n        id\n      }\n      id\n    }\n  }\n  offers: freelancerContracts(first: 0, filters: {statuses: [offer_made]}) {\n    totalCount\n  }\n  interviews: freelancerJobApplications(first: 0, filters: {stage: interview}) {\n    totalCount\n  }\n  screening: freelancerJobApplications(first: 0, filters: {withJobScreening: true}) {\n    totalCount\n  }\n  applications: freelancerJobApplications(first: 0, filters: {statuses: [job_application_sent, job_application_draft]}) {\n    totalCount\n  }\n  ...user_isMember\n  ...user_isClient\n  ...user_isGuest\n}\n\nfragment auth_getRedirectPath on User {\n  status\n  unconfirmedEmail\n  confirmedEmail\n  integrationName\n  ...auth_getDefaultPath\n  ...user_isGuest\n  ...user_isMember\n  ...user_isClient\n}\n\nfragment auth_needsAccountSetup on User {\n  guest\n  confirmedEmail\n  passwordSetupRequired\n}\n\nfragment auth_useAuthGate on User {\n  ...auth_useRedirectPath\n}\n\nfragment auth_useRedirectPath on User {\n  ...auth_getRedirectPath\n}\n\nfragment user_isClient on User {\n  status\n  isClient\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_isMember on User {\n  status\n  isMember\n}\n\nfragment user_useIsClient on User {\n  ...user_isClient\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n\nfragment user_useIsMember on User {\n  ...user_isMember\n}\n"
  }
};
})();

(node as any).hash = "f5481027e4957ebb0425c073c4bfd275";

export default node;
